import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { Dealer } from "src/app/shared/models/Dealer.model";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { UserStatusEnum } from "src/app/shared/models/enums/user-status.enum";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-dealer-setup",
	templateUrl: "./dealer-setup.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class DealerSetupComponent implements OnInit, OnDestroy {
	@Input() dealerIdSelected: string;
	@Output() dealerIdSelectedChange = new EventEmitter<string>();

	changedUsers: User[] = [];

	dealer: Dealer = new Dealer();
	dealerUsers: User[];

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.app.loading(true);
		this.getDealerRecord();
		this.getDealerUser();
	}

	ngOnDestroy(): void {}

	onClose() {
		this.dealerIdSelectedChange.emit(undefined);
	}

	onSave() {
		if (this.changedUsers.length > 0) {
			this.changedUsers.forEach((user) => {
				this.focuslink.userEdit(user);
			});
		}
		this.focuslink.dealerPost(this.dealer);
	}

	async getDealerRecord() {
		const resp = await this.focuslink.dealerGetOne(this.dealerIdSelected, true);
		this.app.loading(false);
		this.dealer = new Dealer(resp);
	}
	async getDealerUser() {
		const resp = await this.focuslink.usersForDealer(this.dealerIdSelected);
		this.dealerUsers = resp.map((i) => new User(i));
		this.dealerUsers = this.dealerUsers.filter(
			(user) => user.role === UserRoleEnum.DEALERADMIN || (user.role === UserRoleEnum.DEALERUSER && user.status !== UserStatusEnum.DELETED)
		);
	}
}
